import React, { FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { StringParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { scrollToElement } from 'apps/fleet-planner/utils/scrollToField'
import { useQueryParams } from 'utils/hooks'
import { getTrackingMethodText } from '../../eld-tracking/utils'

interface IAlertTruckNumberMissingProps {
  trackingMethod?: TRACKING_METHOD_TYPE
}
/**
 * This component will soon replace AlertEnableLiveTracking.tsx
 */
export const AlertTruckNumberMissing: FC<IAlertTruckNumberMissingProps> = ({ trackingMethod }) => {
  const { isMobile } = useBreakpointContext()
  const [, setParams] = useQueryParams({
    focusInput: StringParam,
  })
  const trackingMethodText = getTrackingMethodText(trackingMethod as TRACKING_METHOD_TYPE)

  // Triggers update to URL Search Params, which
  // toggled active inline edit component to `truck`
  const clickHandler = () => {
    setParams({
      focusInput: 'load-assignment',
    })

    /**
     * `setParams` triggers a `useEffect` hook in
     * <LoadDetailsModal /> which opens/expands the
     * <AssignmentInlineEdit /> component.
     *
     * This setTimeout ensures that the scroll action happens after
     * the toggle finishes.
     */
    setTimeout(() => {
      if (isMobile) {
        scrollToElement('.load-assignment', '#main', -150)
      } else {
        scrollToElement('.load-assignment', '.sidebar-wrapper', -180)
      }
    }, 100)
  }

  return (
    <Box data-test='alert-truck-number-missing' component='span'>
      <strong>Add a truck number to enable live tracking.</strong>{' '}
      <Button variant='text' noPadding onClick={clickHandler}>
        Enter your truck number
      </Button>{' '}
      to track this load via {trackingMethodText} ELD.
    </Box>
  )
}
